import React from 'react'
import VirtualList from 'react-virtual-list'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import {withStyles} from '@material-ui/core/styles'
import Hidden from '@material-ui/core/Hidden'
import { getDateFormated } from '../../js/helper'
const styles = theme => ({
     header: {
          [theme.breakpoints.down('sm')]: {
               display: 'none',
             },

     }
})

const MyList = ({ virtual, itemHeight, renderProps, classes, buttons, headerProps, listItemToHide }) => {
    
     const renderHeader = () => {
          return (
               <Grid className={classes.header} style={{marginBottom: '8px', padding: '8px', backgroundColor: '#3f51b5', color: 'white', borderRadius: '8px 8px 0 0'}} container>
               
                         {headerProps.map((headProp, index) => {
                              return (
                                   <Grid key={index} item xs={4} sm={2}>
                                   <Typography variant='subheading' color='inherit'>
                                        {headProp}
                                   </Typography>
                                   </Grid>
                              )
                         })}
                
               </Grid>
          )
     }
     return (
          <div>
               {renderHeader()}
               <div style={virtual.style}>
                    {virtual.items.map((item, index) => {
                         if(item==='undefined') return null
                         return (
                              <ListItem 
                                   buttons={buttons}
                                   itemHeight={itemHeight}
                                   key={index}
                                   item={item}
                                   classes={classes}
                                   renderProps={renderProps}
                                   index={index}
                                   listItemToHide={listItemToHide}
                                   />  
                    )})}
               </div>
          </div>
     )
};

const ListItem = ({itemHeight, item, classes, renderProps, buttons, listItemToHide}) => {
     if(typeof(item)==='undefined') return null
     
     const renderButtons = () => {
          if(buttons===undefined) return null
          return (
               <Grid style={{maxHeight: itemHeight}} item xs={4} sm={2}>
                    {buttons.map((button, index) =><button key={index} onClick={()=>button.onClick(item)} >{button.title}</button>
                    )}
               </Grid>
          )
     }
     if(item.extId===listItemToHide)return null
    return (
        <Card >
         <Grid style={{height: itemHeight, padding: '8px'}} container >
              {renderProps.map((renderProp, index) => {
                   let renderItem = item[renderProp]
                   if(renderProp==='role')
                    if(renderItem==='canidate') {
                         renderItem = <span style={{color: 'green', fontWeight: 'bold' }}>A</span>
                    } else {
                         renderItem = <span style={{color: 'red', fontWeight: 'bold' }}>B</span>
                    }
                    if(renderProp ==='timeStamp' || renderProp==='date')
                         renderItem = getDateFormated(renderItem, 'normal')
               return index>1
                    ?<Hidden key={index} smDown>
                         <ItemProp itemHeight={itemHeight} key={index} itemProp={renderItem} />
                    </Hidden>
                    :<ItemProp itemHeight={itemHeight} key={index} itemProp={renderItem} />
              })}
            
              { buttons===undefined ? null : renderButtons() }
           
            
         </Grid>
         </Card>
    )
}

const ItemProp = ({itemProp}) => {
     
    return (
         <Grid style={{overflow: 'hidden'}} item xs={4} sm={2}>
               <Typography variant='subheading' >
                    {itemProp}
               </Typography>
         </Grid>

    )
}



  const List = VirtualList()(MyList)

  export default withStyles(styles)(List)


// WEBPACK FOOTER //
// ./src/Container/Lists/List.js